<template>
    
    <div class="login">
        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>
        
        <v-app class="login-page-container">
            <div class="logo-brand">
                <img src="../../../common/assets/images/logo-brand.svg" class="logo" alt="4IQ Logo">
            </div>
            <section>
                <v-dialog width="700" persistent class="show-info-popup" v-model="concurrent_dialog_box" >
                    <v-card>
                        <v-toolbar flat dense color="red" dark>
                            <v-icon>warning</v-icon>
                            <v-toolbar-title>Concurrent sessions detected</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon flat :class= "disable_logout ? 'disabled' : ''" @click="concurrent_session_action('clear')">clear</v-icon>
                        </v-toolbar>

                        <v-card-text>
                            You already have an active session from <b> {{concurrent_session_ip}} </b> ip . click on proceed below to continue with this login and logout 
                            from all other active sessions automatically.
                        </v-card-text>

                        <v-divider class="ma-0"></v-divider>
                         
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn id="proceed-btn" color="red" flat @click="concurrent_session_action('proceed')">
                            proceed
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </section>
            <section class="tenantTncSection__container" v-if="showTenantTncPopup">
                <tenantTnc v-on:getTenantTncActions="tenantTncActions($event)" :session="session" :isEndUser="isEndUser"></tenantTnc>
            </section>
        </v-app>

        <app-terms v-if="showTnCView" :app="appDetails.app_name == 'ep' ? 'ep' : ''" :session="session"></app-terms>

        <div :class="configureOTP ? 'qrCodeSectionEnabled' : 'loginpage'" v-else>
            <div v-if="resetToken" class="logindiv smalldiv">
                <div class="login-div resetPassword-div" v-on:submit.prevent>
                    <div id="loginScreenSetPassword" v-on:submit.prevent>
                    <v-form class="reset-password-form" v-model="validForm">
                        <!-- {% csrf_token %} -->
                        <div class="loginpage-logo forgotpage-title">
                            <div class="forgot-password-form-title">
                                <p>Set your New Password</p>
                            </div>
                            <div class="login-page-subtitle">
                                <p>Both passwords need to be the same.</p>
                            </div>
                        </div>

                        <div class="login-content resetpage-content">
                            <div class="input-fields">
                                <v-text-field id="newpassword"
                                clearable dark color=#EFEFEF
                                :append-icon="viewPassword ? 'visibility' : 'visibility_off'" label="New password" :type="viewPassword ? 'text' : 'password'"
                                v-model="newPassword" :rules="[rules.min, rules.strongPassword]" @click:append="viewPassword = !viewPassword">
                                </v-text-field>
                            </div>
                            <div class="input-fields">
                                <v-text-field id="cnewpassword"
                                clearable dark color=#EFEFEF
                                :append-icon="viewconfirmPassword ? 'visibility' : 'visibility_off'" label="Confirm password" :type="viewconfirmPassword ? 'text' : 'password'"
                                v-model="cNewPassword" :rules="[rules.min, rules.np_cnp_match]" @click:append="viewconfirmPassword = !viewconfirmPassword">
                                </v-text-field>
                            </div>
                            <p v-show="showErrorMessage" v-text="errorMessageDetails" class="login-error-msg"></p>
                            <div class="form-element form-button">
                                <button type="submit" class="w3-btn w3-block reset-password signin-btn" :disabled="!validForm" @click="setPassword" v-if="fromWelcomeEmail">Set Password</button>
                                <button type="submit" class="w3-btn w3-block reset-password signin-btn" :disabled="!validForm" @click="setPassword" v-else>Reset Password</button>
                            </div>
                            <div class="form-element loginpage-links" v-if="!fromWelcomeEmail">
                                <span @click="backtoLogin">Go back to Login Page</span>
                            </div>
                        </div>
                    </v-form>
                    </div>
                </div>
            </div>
            <div>
                <confirmationDialog
                :dialogStatus="configureOTP"
                :title="'Set Up 2FA'"
                :eventName="'qrCodeEvent'"
                @qrCodeEvent="qrCodeActions"
                :actions="actionsList">
                    <div class="qrcode__container">
                        <div>
                            <p>You will need a 2FA method for security. Please download and install any authenticator app on your phone. If it is already installed, you can skip this screen!</p>
                            <p>1.Download and install an app (such as Google Authenticator) on your mobile.</p>
                            <p>2. Open the authenticator and scan the QR code.</p>
                        </div>
                    </div>
                    <div class="qr-code" v-html="htmlCode"></div>
                    <div class="qrcode-textfield">
                        <p>3. Enter the 6-digit verification code generated.</p>
                        <label color="#434446">Factor authentication code</label>
                        <v-text-field
                            id="otpInput"
                            placeholder="Enter 2-factor authentication code"
                            solo
                            flat
                            background-color="#F7F7F7"
                            color="#E34E25"
                            v-model="otpCode"
                            append-icon="help_outline" @click:append="openHelpDoc()">
                        </v-text-field>
                    </div>
                </confirmationDialog>
            </div>

            <!-- <div v-if="!resetToken && !configureOTP &&!showProgressBar" class="logindiv" :class="(showForgotpage || showOTPForm) ? 'bigdiv' : 'smalldiv'"> -->
            <div v-if="!resetToken && !configureOTP && !showTenantTncPopup && !displayAccountpage" class="logindiv smalldiv">
                <div class="card login-div loginpage-div" v-on:submit.prevent v-if="!showForgotpage && !showOTPForm && !enableExpirationPage">
                    <v-form class="loginform">
                        <div class="login-page-title login__title-text">
                            <p>Login to your Account</p>
                        </div>
                        <div class="login-content">
                            <div class="input-fields multi-input">
                                <v-text-field id="email" 
                                :class="showLoginMessage ?  'v-input--is-focused' : 'theme-dark'"
                                :error="showLoginMessage ? true : false "
                                label="Username" clearable dark color=#EFEFEF height="30"
                                v-model="email">
                                </v-text-field>
                            </div>
                            <div class="input-fields">
                                <v-text-field id="password" 
                                :class="showLoginMessage ?  'v-input--is-focused' : 'theme-dark'"
                                :error="showLoginMessage ? true : false"
                                :append-icon="viewPassword ? 'visibility' : 'visibility_off'" label="Password" :type="viewPassword ? 'text' : 'password'"
                                dark color=#EFEFEF v-model="password" @click:append="viewPassword = !viewPassword">
                                </v-text-field>
                            </div>
                            <span v-show="showLoginMessage" v-text="loginErrorMessages" class="small red--text text--lighten-1"></span>
                            <div class="d-flex form-element loginpage-links">
                                <v-checkbox v-model="rememberMe" 
                                    color="#e34d25" label="Remember me" id="rememberMeCheckBox"
                                    class="mt-0 pt-0" hide-details>
                                </v-checkbox>
                                <v-spacer></v-spacer>
                                <span id="forgotPasswordPage" class="text-xs-right" 
                                    @click=handleForgotPasswordClick()>Forgot Password?
                                </span>
                                <!-- </span> -->
                            </div>
                            <div class="form-element form-button signin-button-container">
                                <button type="submit" id="signInBtn" class="w3-btn w3-block signin-btn" @click="login()">Sign In</button>
                            </div>
                            <div class="form-element login-seperator" v-if="enable_sso">
                                <hr class="sso-signin-seperator">
                                <span>OR</span>
                                <hr class="sso-signin-seperator">
                            </div>
                            <div class="form-element" v-if="enable_sso">
                                <button type="submit" id="signInBtn" class="w3-btn w3-block signin-btn sso-button" @click="ssoLogin()">Sign in with single sign-on</button>
                            </div>
                            <div class="d-flex form-element login__account-page-actions">
                                <v-icon id="backToAccountIcon" color="#ffffff" @click="backtoAccountPage()" dense>icon-arrow_left</v-icon>
                                <span class="text-xs-left back-to-accountpage" @click="backtoAccountPage()">Back to Account</span>
                                <v-spacer></v-spacer>
                                <span class="text-xs-right login__account-page-link"><a href="mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support" target="new">Contact Constella Support</a></span>
                                <!-- </span> -->
                            </div>
                        </div>
                    </v-form>
                </div>
                 <div class="">
                    <div class="forgotpage-main-div" v-if="showForgotpage">
                        <!-- <v-icon class="ma-2 pa-0 close-icon" title="Close" @click="showForgotpage = !showForgotpage , storeCaptchaToken = ''">cancel</v-icon> -->
                        <div class="login-div forgotpass-div">
                            <div id="loginScreenRecoveryPassword" v-on:submit.prevent>
                            <v-form class="forgot-password-form" v-on:submit.prevent>
                                <div class="loginpage-logo forgotpage-title">
                                    <div class="forgot-password-form-title">
                                        <p>Recovery Password</p>
                                    </div>
                                    <div class="login-page-subtitle">
                                        <p>We will send you a link to reset your password.</p>
                                    </div>
                                </div>
                                <div class="login-content forgotpage-content">
                                    <div class="input-fields multi-input">
                                        <v-text-field id="forgotEmail" 
                                        label="Username" disabled dark color=#EFEFEF
                                        v-model="email">
                                        </v-text-field>
                                    </div>
                                    <div class="input-fields">
                                        <v-text-field id="forgotTenantid"
                                        label="Account" dark color=#EFEFEF disabled
                                        class="input-in-right-panel"
                                        v-model="tenantID">
                                        </v-text-field>
                                    </div>

                                    <!-- vue recaptcha -->
                                    <vue-recaptcha
                                        id="recaptcha"
                                        ref="recaptcha"
                                        class="vueRecaptcha"
                                        @verify="onCaptchaVerified"
                                        @expired="onCaptchaExpired"
                                        :sitekey="captchaSiteKey">
                                    </vue-recaptcha>
                                    <!-- vue recaptcha end -->

                                    <div class="form-element form-button">
                                        <button type="submit" id="sendLinkBtn" class="w3-btn w3-block signin-btn" :class="!storeCaptchaToken ? 'disabledOn' : ''" @click="sendMail()">Send Link</button>
                                    </div>
                                    <div class="d-flex form-element login__account-page-actions">
                                        <v-icon id="backToAccountIcon" color="#ffffff" @click="backtoLoginPage()" dense>icon-arrow_left</v-icon>
                                        <span class="text-xs-left back-to-accountpage" @click="backtoLoginPage()" style="color:white">Back to Login</span>
                                        <v-spacer></v-spacer>
                                        <span class="text-xs-right login__account-page-link"><a href="mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support" target="new">Contact Constella Support</a></span>
                                        <!-- </span> -->
                                    </div>
                                    <!-- <div class="form-element loginpage-links">
                                        <span class="text-xs-left back-to-accountpage" @click="backtoLogin"><v-icon id="backToAccountIcon" color="#ffffff" dense>icon-arrow_left</v-icon> Back to Account</span>
                                    </div> -->
                                </div>
                            </v-form>
                             </div>
                        </div>
                    </div>
                    <div class="login-div forgotpass-div code-validation-form" v-if="showOTPForm">
                        <v-form class="forgot-password-form" v-on:submit.prevent>
                            <div class="login-page-title">
                                <p>2FA Authentication code</p>
                            </div>
                            <div class="login-content forgotpage-content">
                                <div class="input-fields">
                                    <v-text-field id="otpInput"
                                    append-icon="help_outline" @click:append="openHelpDoc()"
                                    label="CODE" class="input-in-right-panel" dark color=#EFEFEF v-model="otpCode">
                                    </v-text-field>
                                </div>
                                <countDown
                                    v-if="enableTimer"
                                    text="2FA attempts exceeded, Please wait for"
                                    :secondsTime="secondsTimer"
                                    :timerDisplayStatus="enableTimer"
                                    @timerCompleted="stopTimer"
                                ></countDown>
                                <div class="form-element loginpage-links inner-addon left-addon right-addon">
                                    <v-checkbox v-model="remember" color="#EFEFEF" label="Remember me for 30 Days"
                                class="mt-0 pt-0" hide-details></v-checkbox>
                                </div>
                                <div class="form-element form-button">
                                    <button type="submit" class="w3-btn w3-block signin-btn" id="validateCode" @click="validateCode" :disabled="enableTimer">Validate Code</button>
                                </div>
                            </div>
                        </v-form>
                    </div>
                </div>

                <!-- Password Expiration code block  -->
                    <div v-if="enableExpirationPage" class="forgotpage-main-div">
                        <div class="login-div forgotpass-div">
                            <v-form class="forgot-password-form" v-on:submit.prevent>
                                <div class="loginpage-logo forgotpage-title">
                                    <div class="password-expiration-title mb-6">
                                        <p>NEW PASSWORD</p>
                                    </div>
                                    <div class="password-expiration-subtitle">
                                        <p>Your password has expired after {{totalExpiredDaya}} days in accordance with your 
                                            Organization policies. Please, set up a new password.</p>
                                    </div>
                                </div>
                                <div class="login-content forgotpage-content expiredPage">
                                    <div class="input-fields">
                                        <v-text-field id="oldexpiredAccPwd" 
                                        type="password"
                                        label="Old password" dark color=#EFEFEF
                                        v-model="expiredPassword"
                                        :error="expiredOldPasswordErrorIndicator"
                                        >
                                        </v-text-field>
                                    </div>
                                    <div class="input-fields">
                                        <v-text-field id="expiredAccPwd" 
                                        type="password"
                                        label="Set new password" dark color=#EFEFEF
                                        v-model="expiredAccountPassword"
                                        :error="showExpirationError"
                                        >
                                        </v-text-field>
                                    </div>
                                    <div class="input-fields">
                                        <v-text-field id="newexpiredPwd"
                                        type="password"
                                        label="Reset your new password" dark color=#EFEFEF
                                        class="input-in-right-panel"
                                        v-model="resetExpiredAccountPassword"
                                        :error="showExpirationError"
                                        >
                                        </v-text-field>
                                    </div>
                                    <div class="passwordExpirationError" :class="(showExpirationError || showSuccessMessage || expiredOldPasswordErrorIndicator) ? 'displayError': 'hideError'">
                                        <span>{{expirationErrorMessage}}</span>
                                    </div>
                                    <div class="form-element form-button">
                                        <button type="submit" id="sendLinkBtn" class="w3-btn w3-block signin-btn" @click="expirationLogin()">Login</button>
                                    </div>
                                </div>
                            </v-form>
                        </div>
                    </div>
                <!-- Password Expiration code block-END  -->
            </div>

            <div v-if="displayAccountpage" class="logindiv accountPageView">
                <div class="card login-div loginpage-div" v-on:submit.prevent v-if="!showForgotpage && !showOTPForm && !enableExpirationPage && !resetToken">
                    <v-form class="loginform">
                        <div class="login-page-title login__title-text">
                            <p>Login to your Account</p>
                        </div>
                        <div class="logo-message">
                            <v-text-field class="account-text" id="tenantid" dark color=#ffffff
                            :clearable="true" 
                            :autofocus="true"
                            :error="showStatusMessage ? true : false"
                            v-model="tenantID"
                            label="Account"
                            hide-details></v-text-field>
                        </div>
                        <div class="login__account-page-actions status-message" v-if="showStatusMessage">
                            <span class="login__account-status-message">{{statusMessageText}}</span>
                        </div>
                        <div class="login__account-page-actions">
                            <button type="submit" 
                                id="signInBtn" class="w3-btn w3-block signin-btn" 
                                :class="showStatusMessage ? 'nextDisabled': ''"
                                @click="enableSSOButton()">Next  
                                <v-icon small>icon-arrow_right</v-icon>
                            </button>
                        </div>
                        <div class="login__account-page-actions">
                            <span class="login__account-page-link"><a href="mailto:support@constellaintelligence.com?subject=Constella IDHunt Core Support" target="new">Contact Constella Support</a></span>
                        </div>
                    </v-form>
                </div>
            </div>
        </div>
        <div v-if="showProgressBar" class="logindiv smalldiv">
            <div class="login-div progressBar-div">
                <p class="text-xs-center display-1">WELL DONE</p>
                <div class="container">
                    <div class="loginpage-logo">
                        <img src="../../../common/assets/images/Logo_4iQ-DEEP_with_R_MAIN.svg" class="logo" alt="4IQ Logo">
                    </div>
                    <div class="pt-3">
                        <v-progress-linear
                        color="cyan accent-4"
                        indeterminate
                        rounded
                        height="6"
                        ></v-progress-linear>
                    </div>
                </div>
            </div>
        </div>
        <backupCodesModal v-if="showBackupCodesPopup" @close="showBackupCodesPopup = false; showTenantTnc()" :fromHeader="false" :regenerate="regenerate" :dialogStatus="showBackupCodesPopup"></backupCodesModal>
    </div>

</template>

<script>

import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css'
import VueCookies from 'vue-cookies';
import appTerms from '../../../common/components/appTerms.vue';
import tenantTnc from '../../../common/components/tenantTnc.vue';
import Snackbar from "../../../common/components/snackbar";
import VueLoading from 'vuejs-loading-plugin';
import VueRecaptcha from 'vue-recaptcha';
import backupCodesModal from '../../../common/components/backupCodesModal';
import confirmationDialog from '../../../epsrc/components/common/confirmationDialog';
import countDown from '../Login/countDownTimer';

Vue.use(VueLoading,{
	text:'',
	classes: ['loading-div']
});
Vue.use(Vuetify);

export default {
    name: 'Login',
    data () {
        return {
            accountEditable: false,
            email: null,
            tenantID:"",
            password: "",
            remember: true,
            newPassword: "",
            cNewPassword: "",
            showForgotpage: false,
            resetToken: "" ,
            showOTPForm: false,
            otpCode: "",
            configureOTP: false,
            htmlCode: false,
            fromWelcomeEmail: false,
            concurrent_dialog_box : false,
            concurrent_session_ip:'',
            showTnCView: false,
            session: null,
            appDetails: {},
            hide:null,
            captchaSiteKey:'',
            storeCaptchaToken:'',
            showInvalidCaptchaErrorMessage: false,
            rememberMe: true,
            cookiesData: {},
            enableSetCookie: true,
            validForm: false,
            rules: {
                min: v => v.length >= 8 || 'Min 8 characters',
                np_cnp_match: v => v == this.newPassword || ('The confirm Password and password you entered don\'t match'),
                strongPassword: v => new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\\\\~`!@#\$%\^&\*()_+=,.<>/:;\"'?\\]{}|[\-])(?=.{8,})").test(v) || ('The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character.')
            },
            viewPassword: false,
            viewconfirmPassword: false,
            showSnackbar: false,
            snackbarColor: null,
            snackbarMessage: null,
            showProgressBar: false,
            showBackupCodesPopup: false,
            regenerate: false,
            noappnodoc: false,
            actionsList: [
                {'text': 'CANCEL', 'action': 'cancelQRCode', 'status': 'enabled'},
                {'text': 'CONFIRM', 'action': 'confirmQRCode', 'status': 'enabled'},
            ],
            loginErrorMessages: '',
            showLoginMessage: false,
            userRole: '',
            showErrorMessage: false,
            errorMessageDetails: null,
            alreadyExistingPasswordErrorText: "You have already used that password, try another.",
            enableExpirationPage: false,
            totalExpiredDaya:'',
            expiredAccountPassword: '',
            resetExpiredAccountPassword: '',
            showExpirationError: false,
            expirationErrorMessage: '',
            expirationRules: {
                min: v => v.length >= 8 || v.length > 0 ? (this.showExpirationError = true, this.expirationErrorMessage = "Strong Password" ) : this.showExpirationError = false,
                match_pwd: v => v == this.expiredAccountPassword || '',
                new_pwd_match: v => v == this.resetExpiredAccountPassword || '',
                strongPassword: v => new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})").test(v) || ('The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character'),
            },
            expiredCurrentPassword: '',
            expiredPassword: '',
            expiredOldPasswordErrorIndicator: false,
            showSuccessMessage: false,
            tenantTncStatus: false,
            showTenantTncPopup: false,
            isEndUser: '',
            enable_sso: false,
            user_via_redirection: false,
            disable_logout : false,
            displayAccountpage: true,
            showStatusMessage: false,
            statusMessageText: 'Please enter a correct Account',
            countDown: 30,
            secondsTimer: 0,
            enableTimer: false,
            csrftoken: null
        }
    },
    components: {
        appTerms,
        'vue-recaptcha': VueRecaptcha,
        Snackbar,
        backupCodesModal,
        confirmationDialog,
        tenantTnc,
        countDown
        // loginplrogress
    },
    created(){
        var self = this;
        self.getSiteKey();
        sessionStorage.clear();
        self.resetLoginScreen();
        // self.email = VueCookies.get('user') || null;
        // const encryptedPassword = VueCookies.get('password') || null;
        // self.password = encryptedPassword ? cryptr.decrypt(encryptedPassword) : null;
        // self.rememberMe = VueCookies.get('remember-me') || false;
        let hostname = window.location.hostname.split('.').length > 3 ? window.location.hostname.split('.')[0] : null;
        // self.disabletenantID = hostname != null ? true : false; 
        // let hostname = window.location.hostname.split('.')[0] || null;
        // self.tenantID = VueCookies.get('tenantID') || hostname;
        if(window.location.search){
            let searchData = window.location.search.split('?')[1];
            if(searchData && searchData.split('=')[0] == 'token' && searchData.split('token=')[1]){
                self.resetToken = searchData.split('token=')[1];
            }else if(searchData && searchData.split('=')[0] == 'newtoken' && searchData.split('newtoken=')[1]){
                self.resetToken = searchData.split('newtoken=')[1];
                self.fromWelcomeEmail = true;
            }
            else if(searchData && searchData.split('=')[0] == 'acs' && searchData.split('acs=')[1]){
                this.tenantID = searchData.split('acs=')[1]
                this.user_via_redirection = true
                this.ssoLoginAcs(searchData.split('acs=')[1]);
            }
        }
        // Check for SSO
        if(window.location.hostname.split('.').length>3){
            this.user_via_redirection = false
            this.tenantID=window.location.hostname.split('.')[0]
            // let searchData = window.location.search.split('?')[1];
            // if(searchData && searchData.split('=')[0] == 'acs' && searchData.split('acs=')[1]) return
            // else {
            //     if(searchData && searchData.split('=')[0] == 'loggedOut' && searchData.split('loggedOut=')[1]) return
            //     // this.verifySSOStatus()
            //     if(this.enable_sso){
            //         this.user_via_redirection = true
            //         this.ssoLogin()
            //     } 
            // }
        }
        $.ajax('/',{
            type:'GET',
            headers: {"ACCEPT": "application/json"},
            statusCode:{
                204: function(){
                    //console.log("Not logedin");
                },
                200: function(){
                    window.location = "/";
                }
            },
            success:function(data){
                // nothing!!
                //console.log("in success");
            }
        });

        $.ajax('/get_cookies/', {
            type:'GET',
            data:{
                cookies: "all"
            },
            headers: {"ACCEPT": "application/json"},
            statusCode:{
                200: function(data){
                    self.email = data.cookies.user || null;
                    self.rememberMe = data.cookies['remember-me'] || false;
                    self.tenantID = data.cookies.tenantID || hostname;
                    self.csrftoken = data.cookies.csrftoken || null;
                }
            }
        }
        );

        // if(self.tenantID) {
        //     // Checking SSO for the tenant
        //     self.enableSSOButton();
        // }
    },
    mounted(){
        if(window.location.search.substr(6) && window.location.search.startsWith('?next=')){
            window.location.hash = "#/";
        }
        if(this.resetToken === VueCookies.get('resetToken')){
            this.displaySnackbar('warning', 'Link expired.........');
            setTimeout(function(){
                location.href="/login";
            },2000);
        }
    },
    watch:{
        tenantID(){
            var self = this;
            if (self.tenantID){
                self.showStatusMessage = false;
            }
        }
    },
    methods: {
        resetLoginScreen() {
            self.displayAccountpage = true;
            self.showStatusMessage = false;
        },
        getSiteKey(){
            var self = this;
            Vue.http.get("/captcha/site_key")
            .then((res) => {
                self.captchaSiteKey = res.data ? JSON.parse(res.data)['site_key'] : '';
            }, (error) => {
               console.log("let's display error message");
            });
        },
        onCaptchaVerified(response){
            var self = this;
            self.storeCaptchaToken = response;
        },
        onCaptchaExpired(){
            var self = this;
            self.$refs.recaptcha.reset();
        },
        getCSFRToken(name){
            var cookieValue = null;
            if (document.cookie && document.cookie != '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i].trim();
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) == (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },
        validateField(field, fieldName, scope){
            var self = this;
            if(field && field.length >= 1){
                return false;
            }else{
                // loginErrorMessages
                if (scope) {
                    self.showLoginMessage = true;
                    self.loginErrorMessages = fieldName+' cannot be Empty';
                    self.$loading(false);
                } else {
                    self.displaySnackbar('error-banner', fieldName+' cannot be Empty');
                }
                return true;
            }
        },
        login(){
            var self = this;
            self.$loading(true);
            self.showForgotpage = false;
            self.showOTPForm = false;
            var invalidUsername = self.validateField(self.email, 'Username', 'login');
            var invalidTenantid = self.validateField(self.tenantID, 'Account', 'login');
            var invalidPassword = self.validateField(self.password, 'Password', 'login');
            var csrfTOken = this.getCSFRToken('csrftoken');
            if(!invalidUsername && !invalidPassword && !invalidTenantid){
                var postData = {
                    'username': self.email.trim(),
                    'tenantid': self.tenantID.trim(),
                    'password': self.password,
                    'csrfmiddlewaretoken': csrfTOken
                };
                $.ajax('/login/',{
                    type:'POST',
                    data: postData,
                    headers: {"ACCEPT": "application/json"},
                    statusCode: {
                        500: function(err) {
                            self.loginFailed(err, 'login');
                        },
                        404: function(err) {
                            self.loginFailed(err, 'login');
                        },
                        403: function(err) {
                            self.loginFailed(err, 'login');
                        },
                        401: function (err) {
                            window.location = '/login';
                        },
                        430: function (err) {
                            self.showOTPForm = true;
                            self.$loading(false);
                        },
                        416: function (data) {
                            let res = JSON.parse(data.responseText);
                            self.totalExpiredDaya = res.password_expiration_days || '#';
                            self.enableExpirationPage = res.status;
                            self.expiredCurrentPassword = res.currentPassword;
                            self.$loading(false);
                        },
                        201:function(res){
                            // enable alert dialog box
                            self.concurrent_dialog_box = true;
                            if(res.existing_ip == null || res.existing_ip == undefined){
                                self.concurrent_session_ip = "xxx.xxx.xxx.xxx";
                            }
                            else{
                                self.concurrent_session_ip = res.existing_ip;
                            }
                            self.cookiesData['user'] = self.rememberMe ? self.email : '';
                            self.cookiesData['tenantID'] = self.tenantID;
                            self.cookiesData['remember-me'] = self.rememberMe ? true : false;
                            self.enableSetCookie = self.rememberMe ? true : false;
                            self.$loading(false);
                        },
                        200: function(data){
                            self.cookiesData['user'] = self.rememberMe ? self.email : '';
                            self.cookiesData['tenantID'] = self.tenantID;
                            self.cookiesData['remember-me'] = self.rememberMe ? true : false;
                            self.enableSetCookie = self.rememberMe ? true : false;
                            if (data.mfa_timer > 0) {
                                self.setTimerParams('disable', data.mfa_timer, true);
                            } else {
                                self.setTimerParams('enabled', 0, false);
                            }
                            self.loginSuccess(data);
                        }
                    }
                });
            }
        },

        verifySSOStatus(){
            var self = this;
            self.showStatusMessage = false;
            self.$loading(true);
            var postData = {
                'tenantid': self.tenantID.trim()
            };
            var url = "/get_tenant_sso_status/"
            $.ajax(url, {
                type:'POST',
                data: postData,
                headers: {"ACCEPT": "application/json",'Access-Control-Allow-Origin': '*'},
                crossOrigin:false,
                async: false,
                statusCode: {
                    200: function(data){
                            self.enable_sso = data.enable_sso;
                            self.displayAccountpage = false;
                            self.$loading(false);
                    },
                    202: function(err) {
                        self.enable_sso=err.enable_sso;
                        self.showStatusMessage = true;
                        self.$loading(false);
                    },
                    403: function(err) {
                        self.loginFailed(err,'login')
                        self.$loading(false);
                    },
                    401: function (err) {
                        window.location = '/login';
                        self.$loading(false);
                    },
                }
            });
        },

        enableSSOButton(){
            var self = this;
            if (!self.tenantID) {
                self.showStatusMessage = true;
            } else {
                self.showStatusMessage = false;
                self.verifySSOStatus()
            }
        },

        ssoLogin() {
            var self = this;
            console.log(window.location.host)
            var postData = {
                'tenantid': this.tenantID.trim(),
                'host_info':window.location.host
            };
            var url = "/saml/?sso"
            $.ajax(url, {
                type:'POST',
                data: postData,
                headers: {"ACCEPT": "application/json"},
                statusCode: {
                    200: function(data){
                        // microsoft login URL
                        console.log(data, "***********");
                        if(data.name == 'sso') {
                            window.location.href = data.sso_url;
                        } else {
                            window.location = "/index.html#/";
                        }
                    },
                    403: function(err) {
                            self.loginFailed(err, 'login');
                    },
                }
            });
        },

        ssoLoginAcs(tenantId) {
            var self = this;
            // 'tenantid': self.tenantID
            // window.location.href = '/saml/?sso&tenantId='+this.tenantID;
            var postData = {
                'tenantid': tenantId,
                'host_info':window.location.host
            };
            var url = "/saml/?login"
            $.ajax(url, {
                type:'POST',
                data: postData,
                headers: {"ACCEPT": "application/json"},
                statusCode: {
                    200: function(data){
                        self.loginSuccess(data);
                    },
                    201:function(res){
                            // enable alert dialog box
                            self.concurrent_dialog_box = true;
                            if(res.sso_redirected_user) self.disable_logout = true
                            if(res.existing_ip == null || res.existing_ip == undefined){
                                self.concurrent_session_ip = "xxx.xxx.xxx.xxx";
                            }
                            else{
                                self.concurrent_session_ip = res.existing_ip;
                            }
                            self.$loading(false);
                    },
                    500: function(err) {
                        self.errorMessage = JSON.parse(err.responseText)["message"];
                        // self.showLoginMessage = true;
                        // self.loginErrorMessages = self.errorMessage;
                        self.showStatusMessage = true;
                        self.statusMessageText = self.errorMessage;
                        self.$loading(false);
                    },
                    403: function(err) {
                            self.loginFailed(err, 'login');
                    },
                    404: function(err) {
                            self.loginFailed(err, 'login');
                    },
                    401: function (err) {
                        window.location = '/login';
                    },
                }
            });
        },


        loginFailed(err, scope){
            var self = this;
            let errorMessage = err.status == 404 ? 'Unable to process your request' : err.responseText ? JSON.parse(err.responseText)["error"] : null;
            if(err.status === 500 && JSON.parse(err.responseText)["message"] == 'User dont have any apps/docs enabled so please contact system administrator'){
                errorMessage = JSON.parse(err.responseText)["message"];
            }
            if (scope) {
                self.showLoginMessage = true;
                self.loginErrorMessages = errorMessage;
                self.$loading(false);
            } else {
                self.displaySnackbar('error-banner', errorMessage || 'Invalid Credentials');
            }
        },

        loginSuccess(data){
            var self = this;
            sessionStorage.setItem('email', self.email);
            sessionStorage.setItem('tenantName', self.tenantID);
            sessionStorage.setItem('tenantSchemaName', data['app_details']['schema_name']);
            self.appDetails = data['app_details'] || {};
            self.session = data['session'];
            // Storing tenant tnc status
            if (data.tenant_tnc_status) {
                self.isEndUser = data.is_enduser;
                self.tenantTncStatus = data.tenant_tnc_status;
            }
            if(data.has_no_apps_docs){
                self.noappnodoc = true;
            } else {
                self.noappnodoc = false;
            }
            if (data.role) {
                self.userRole = data.role;
            }
            if(data.mfa_status == 0){
                self.configureOTP = true;
                Vue.http.get("/settings/mfa/configure/")
                    .then((data) => {
                        try{
                            console.log(data);
                            self.htmlCode = data.data;
                        }
                        catch(err){
                            console.log("error is:",err);
                        }
                        finally{
                            this.$loading(false);
                        }
                    }, (error) => {
                        this.$loading(false);
                        console.log("enable verification failed with error:" + error)
                });
            }else if(data.mfa_status == 2){
                self.showOTPForm = true;
            }else if(data.accept_tnc){

                self.showTnCView = true;
            }else{
                self.showTenantTnc();
                // self.userRedirect();
            }
            self.$loading(false);
        },

        setCookie(cookiesData, cookieStatus) {
            var postData = {
                'cookie_obj': JSON.stringify(cookiesData),
                'cookie_status': cookieStatus
            };
            $.ajax('/set_or_remove_cookie/', {
                type:'POST',
                data: postData,
                headers: {"ACCEPT": "application/json"},
                crossOrigin:false,
                async: false,
                statusCode: {
                    200: function(data){
                        // console.log("Updated cookies info",data)
                    }
                }
            });
        },

        
        // 
        showTenantTnc() {
            var self = this;
            self.configureOTP = false;
            if (self.tenantTncStatus) {
                self.showTenantTncPopup = true;
            } else {
                self.showTenantTncPopup = false;
                self.userRedirect();
            }
        },
        tenantTncActions(status) {
            var self = this;
            if(status == 'accepted') {
                self.userRedirect();
            } else {
                window.location = '/logout';
            }
            setTimeout(function(){ 
                self.showTenantTncPopup = false;
            }, 1000);
        },
        userRedirect() {
            let self = this;
            self.$loading(false);
            self.setCookie(self.cookiesData, self.enableSetCookie);
            // self.showProgressBar = true;
            //TODO - remove while PR
            // setTimeout(() => {
                let superUser = self.appDetails['schema_name'] == 'public' && self.userRole == 'User' ? true : false;
                if(self.noappnodoc){
                    if (self.userRole === 'tenantAdmin' || superUser) {
                        window.location = "/index.html#/";
                    } else {
                        window.location = "/index.html#/noapp_nodoc";
                    }
                }else if(window.location.search.substr(6) && window.location.search.startsWith('?next=')){
                    window.location = window.location.search.substr(6);
                }else if(self.appDetails['app_name'] && self.appDetails['app_name'] != 'app') {
                    if(superUser) {
                        window.location = "/index.html#/";
                    } else if(self.appDetails['app_name'] == 'doc'){
                        window.location = "/index.html#/docs/all";
                    }else if(self.appDetails['app_name']){
                        window.location = "/apps/"+self.appDetails['app_name']+"/index/?at="+self.session;
                    }
                }else{
                    window.location = "/index.html#/";
                    // location.assign("/index.html#/");
                }
            // }, 3000);
        },

        qrCodeActions(data) {
            var self = this;
            if(data.action == 'confirmQRCode') {
                var self = this, formData = new FormData();
                self.$loading(true);
                var csrfTOken = this.getCSFRToken('csrftoken');
                var secret_key = $('input[name="secret_key"]').val();
                var otp_type = $('input[name="otp_type"]').val();
                formData.append('csrfmiddlewaretoken', csrfTOken);
                formData.append('verification_code', self.otpCode);
                formData.append('secret_key', secret_key);
                formData.append('otp_type', otp_type);
                var invalidOTP = self.validateField(self.otpCode, 'OTP Code');
                if(!invalidOTP){
                    Vue.http.post("/settings/mfa/enable/", formData)
                    .then((data) => {
                        try{
                            self.showBackupCodesPopup = true;
                        }
                        catch(err){
                            console.log("error is:",err);
                        }
                        finally{
                            this.$loading(false);
                        }
                    }, (error) => {
                        self.displaySnackbar('error-banner', 'Invalid Verification Code');
                        console.log("OTP config failed with error:" + error)
                    });
                }
            } else {
                self.configureOTP = false;
            }
        },

        setTimerParams(actionStatus, secondsTimerParam, enableTimerParam) {
            var self = this;
            self.actionsList[1].status = actionStatus;
            self.secondsTimer = secondsTimerParam;
            self.enableTimer = enableTimerParam;
        },

        stopTimer() {
            var self = this;
            self.enableTimer = false;
            self.actionsList[1].status = 'enabled';
        },

        openHelpDoc(){
            let routeData = this.$router.resolve('/2fadocs');
            window.open(routeData.href, '_blank');
        },

        validateCode(){
            var self = this, formData = new FormData();
            self.enableTimer = false;
            self.$loading(true);
            var csrfTOken = this.getCSFRToken('csrftoken');
            formData.append('csrfmiddlewaretoken', csrfTOken);
            formData.append('verification_code', self.otpCode);
            formData.append('remember', self.remember);
            var invalidOTP = self.validateField(self.otpCode, 'OTP Code');
            if(!invalidOTP){
                Vue.http.post("/settings/verify/token/", formData)
                .then((data) => {
                    var statusCode = data.status;
                    if (statusCode == 201) {
                        self.setTimerParams('disable', data.mfa_timer, true);
                    }
                    else {
                        self.setTimerParams('enabled', 0, false);
                        let resData = JSON.parse(data.data);
                        if(resData && resData.generated_codes){
                            self.showBackupCodesPopup = true;
                            self.regenerate = true;
                        } else {
                            try{
                                // self.userRedirect();
                                self.showTenantTnc();
                            }
                            catch(err){
                                console.log("error is:",err);
                            }
                        }
                    }
                    self.$loading(false);
                }, (error) => {
                    self.displaySnackbar('error-banner', 'Invalid Verification Code');
                    // console.log("Verification failed with error:" + error)
                });
            }
        },

        sendMail(){
            var self = this, formData = new FormData();
            self.$loading(true);
            // var csrfTOken = $('input[name="csrfmiddlewaretoken"]').val();
            var csrfTOken = self.getCSFRToken('csrftoken');
            formData.append('g-recaptcha-response',self.storeCaptchaToken)
            formData.append('csrfmiddlewaretoken', csrfTOken);
            formData.append('email', self.email);
            formData.append('tenantid', self.tenantID);
            var invalidForgotEmail = self.validateField(self.email, 'Username');
            if(!invalidForgotEmail){
                self.$refs.recaptcha.reset();
                Vue.http.post("/password_reset/", formData)
                .then((data) => {
                    try{
                        if(data && data.status == 201){
                            self.displaySnackbar('error-banner', 'Couldn\'t find an account with this Username');
                        }else{
                            self.displaySnackbar('success-banner', 'Successfully sent an email with reset password link')
                        }
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        this.$loading(false);
                    }
                }, (error) => {
                    if(error.status === 403 && JSON.parse(error.data)["message"] === 'Invalid Captcha'){
                        self.displaySnackbar('error-banner', 'Please click on the check box to verify that you are not a robot');
                    }
                    self.$loading(false);
                    //console.log("api failed with error:" + error)
                });
            }
            self.$refs.recaptcha.reset();
        },
        setPassword(){
            var self = this, formData = new FormData();
            self.showErrorMessage = false;
            self.errorMessageDetails = null;
            self.$loading(true);
            // var csrfTOken = $('input[name="csrfmiddlewaretoken"]').val();
            var csrfTOken = this.getCSFRToken('csrftoken');
            formData.append('csrfmiddlewaretoken', csrfTOken);
            formData.append('new_password1', self.newPassword);
            formData.append('new_password2', self.cNewPassword);
            var invalidNewPassword = self.validateField(self.newPassword, 'New Password');
            var invalidCNewPassword = self.validateField(self.cNewPassword, 'Confirm New Password Field');
            if(!invalidNewPassword && !invalidCNewPassword && self.validForm){
                let set_password_url = "/reset/" + self.resetToken + "/";
                if(self.fromWelcomeEmail){
                    set_password_url = "/set_password/" + self.resetToken + "/";
                }
                Vue.http.post(set_password_url, formData)
                .then((data) => {
                    try{
                        if(data.status == 201){
                            self.displaySnackbar('error-banner', 'Please enter a secure password');
                        }
                        else{
                            // self.successMessage = true;
                            // setTimeout(function(){ 
                            // self.successMessage = false;
                            // }, 3000);
                            // location.href = "/login";
                            VueCookies.set('resetToken', self.resetToken);

                            self.displaySnackbar('success-banner', 'Password changed successfully, Will redirect to Login page Soon');
                            setTimeout(() => {
                                window.location = '/logout';
                            }, 2000);
                        }
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.$loading(false);
                    }
                }, (error) => {
                    if (error.status === 403) {
                        let errorData = JSON.parse(error.data);
                        if (errorData.message && errorData.message === "password already exists") {
                            self.showErrorMessage = true;
                            self.errorMessageDetails = "You have already used that password, try another.";
                        } 
                        self.$loading(false);
                    } else {
                    self.displaySnackbar('error-banner', 'Something went wrong..!');
                    }
                    //console.log("api failed with error:" + error)
                });

            }
        },
        backtoLogin(){
            location.href = "/login";
        },
        // Contact 4IQ form
        open4iQSupportForm(){
            // location.href = "/support4iQ.html";
            this.$router.push('/support4iQ');
        },

        // combining both actions 
        concurrent_session_action(action){
            var self = this;
            self.$loading(true);
            if(action == 'proceed'){
                $.ajax('/clear_sessions/',{
                    type:'POST',
                    statusCode: {
                        403: function(data){
                            sessionStorage.clear();
                            self.$loading(false);
                            location.href = "/login";
                        },   
                        200: function(data){
                            self.concurrent_dialog_box = false;
                            self.loginSuccess(data);
                        },
                        500: function(err) {
                            self.loginFailed(err);
                        }
                    }
                });
            }
            else{
                self.$loading(false);
                sessionStorage.clear();
                window.location = '/logout';
            }
        },
        // Functions to display snackbar for success/error messages
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
            self.$loading(false);
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        expirationLogin() {
            var self = this, formData = new FormData();
            var csrfTOken = this.getCSFRToken('csrftoken');
            self.expiredOldPasswordErrorIndicator = false;
            self.showSuccessMessage = false;
            let newLen = self.resetExpiredAccountPassword.length > 2 ? true : false;
            let oldLen = self.expiredAccountPassword.length > 2 ? true : false;
            if (self.expiredPassword == self.resetExpiredAccountPassword) {
                self.showExpirationError = true;
                self.expirationErrorMessage = "You have already used that password, try another.";
            }
            else if (self.expiredAccountPassword == self.resetExpiredAccountPassword && newLen && oldLen) {
                self.showExpirationError = false;
                formData.append('csrfmiddlewaretoken', csrfTOken);
                formData.append('username', self.email);
                formData.append('tenantid', self.tenantID);
                formData.append('old_password', self.expiredPassword);
                formData.append('new_password', self.expiredAccountPassword);
                formData.append('confirm_new_password', self.resetExpiredAccountPassword);
                Vue.http.post("/change_expiration_Password/", formData).then(
                    (data) => {
                        try {
                            if (data.status == 201) {
                                self.showExpirationError = true;
                                self.expirationErrorMessage = 'Please enter a secure password';
                            } else {
                                self.showSuccessMessage = true;
                                self.expirationErrorMessage = 'Password changed successfully, Will redirect to Login page Soon';
                                setTimeout(() => {
                                    window.location = '/logout';
                                }, 2000);
                            }
                        } catch (error) {
                            console.log("error is:",err);
                        }
                    }, 
                    (error) => {
                        let errorData = JSON.parse(error.data);
                        if (error.status === 403) {
                            if (errorData.message && errorData.message === "password already exists") {
                                self.showExpirationError = true;
                                self.expirationErrorMessage = "You have already used that password, try another.";
                            } 
                        } else if (error.status === 404){ 
                            self.expiredOldPasswordErrorIndicator = true;
                            self.expirationErrorMessage = errorData.message;
                        }
                        else {
                            self.displaySnackbar('error-banner', 'Something went wrong..!');
                        }
                    });
            } else {
                self.showExpirationError = true;
                self.expirationErrorMessage = 'Your new password does not match each other';
            }
        },
        backtoLoginPage() {
            var self = this;
            self.showForgotpage = false;
        },
        backtoAccountPage() {
            var self = this;
            self.displayAccountpage = true;
            self.showLoginMessage = false;
        },
        handleForgotPasswordClick() {
            var self = this;
            var InvalidUsername = self.validateField(self.email, 'Username', 'login');
            if(!InvalidUsername) {
                self.showForgotpage = !self.showForgotpage;
                self.storeCaptchaToken = '';
            }
        }
    }
}
</script>
